<template>
  <div class="main">
    <div class="left">
      <div class="left_title">
        专业目录
      </div>
      <Navbar @tableData="gettableData($event)"></Navbar>
    </div>
    <div class="right">
      <div class="right_title">
        班级信息管理
      </div>
      <div class="right_function">
        <div></div>
        <div class="">
          <!-- <Button>
            导入模板下载
          </Button>
          <Button style="margin-left:10px">
            导入
          </Button> -->
          <CModal msg="新增" icon="md-add" :parentId="tableData" @tableData="gettableData($event)"></CModal>
          <CModal msg="编辑" icon="ios-create" :handleSelectData="currentRow"></CModal>
          <CModal msg="删除" icon="md-trash" :handleSelectData="currentRow" @tableData="gettableData($event)"></CModal>
        </div>
      </div>
      <el-table ref="singleTable" :data="tableData" highlight-current-row @current-change="handleCurrentChange" style="width: 100%" stripe max-height="700">
        <el-table-column type="index" width="80" label="序号" align="center"> </el-table-column>
        <el-table-column property="orgname" label="班级名称" align="center"> </el-table-column>
        <el-table-column property="orgcode" label="班级编号" align="center"> </el-table-column>
        <el-table-column property="manager" label="负责人" align="center"> </el-table-column>
        <el-table-column property="phone" label="联系电话" align="center"> </el-table-column>
        <el-table-column property="description" label="备注" align="center"> </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import Api from '../../api/index'
import Navbar from '../../components/system/classMenu'
import CModal from '../../components/system/classBtn'

export default {
  data() {
    return {
      searchData: '',
      tableData: [],
      currentRow: null
    }
  },
  components: {
    Navbar,
    CModal
  },
  created() {},
  mounted() {},

  methods: {
    //获取子菜单列表
    gettableData(val) {
      this.tableData = val
    },
    //搜索按钮
    searchBtn() {
      console.log(this.searchData)
    },
    //表格选中项
    handleCurrentChange(val) {
      console.log(val)
      this.currentRow = val
    }
  }
}
</script>
<style lang="less" scoped>
.main {
  display: flex;
  justify-content: space-between;
  height: 100%;
  width: 100%;

  .left,
  .right {
    border: 1px solid #f0eeff;
    border-radius: 3px;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  }
  .left {
    width: 12%;
    height: 100%;
    background-color: #fff;
    .left_title {
      height: 40px;
      line-height: 40px;
      text-align: center;
      font-size: 15px;
      font-weight: 600;
      color: #fff;
      background-color: #1874cd;
    }
  }
  .right {
    width: 87%;
    height: 100%;
    background-color: #fff;

    .right_function {
      display: flex;
      justify-content: space-between;
      padding: 10px 20px;
    }
    .right_title {
      color: #666;
      font-size: 15px;
      font-weight: 600;
      border-bottom: 1px solid #c7ebf3;
      height: 40px;
      line-height: 40px;
      padding-left: 20px;
    }
  }
}
</style>
